<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="`${title}质检信息`"
      width="830px"
      :innerScroll="false"
      :loading="loadingButtom"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <div>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px" size="small" class="content">
          <el-row>
            <el-col :span="12">
              <el-form-item label="质检人:">
                <el-input v-model="addForm.qualityPersonName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="年/月:" prop="yearMonth">
                <el-date-picker v-model="addForm.yearMonth" type="month" value-format="yyyy-MM" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="周数:" prop="week">
                <el-input v-model="addForm.week" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="登记日期:" prop="registerDt">
                <el-date-picker v-model="addForm.registerDt" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会话日期:" prop="sessionDt">
                <el-date-picker v-model="addForm.sessionDt" type="date" value-format="yyyy-MM-dd" placeholder="年/月/日" :picker-options="pickerOptions" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="店铺名称:" prop="storeCode">
                <el-select v-model="addForm.storeCode" filterable placeholder="请选择" @change="getUserInfo(addForm.storeCode, 1)">
                  <el-option
                    v-for="item in storeList"
                    :key="item.storeCode"
                    :label="`${item.platformName}-${item.fullName}`"
                    :value="item.storeCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户ID:" prop="customerId">
                <el-input v-model.trim="addForm.customerId" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客服ID:" prop="customerServiceId">
                <el-select v-model="addForm.customerServiceId" filterable placeholder="请选择" @change="getUserInfo">
                  <el-option
                    v-for="item in customerServiceIdList"
                    :key="item.platCustomerServiceId"
                    :label="item.platCustomerServiceId"
                    :value="item.platCustomerServiceId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名:" prop="name">
                <el-input v-model="addForm.name" placeholder="请输入" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="岗位:" prop="workJobs">
                <el-input v-model="addForm.workJobs" placeholder="请输入" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="违规项:" prop="violation">
                <el-select v-model="addForm.violation" filterable placeholder="请选择" @change="onviolationChange">
                  <el-option v-for="item in violationQueryList" :key="item.scene" :label="item.scene" :value="item.scene" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="质检来源:" prop="qualitySource">
                <el-select v-model="addForm.qualitySource" filterable placeholder="请选择">
                  <el-option v-for="item in sysConfigList" :key="item.confName" :label="item.confName" :value="item.confName" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="扣分:" prop="deductPoints">
                <el-input-number v-model="addForm.deductPoints" type="number" :min="0" :precision="1" controls-position="right" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申诉时效:" prop="appealTime">
                <el-input v-model="addForm.appealTime" placeholder="请输入" />
                <span style="margin-left: 5px">天</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="质检截图:" prop="screenshotList" :class="{ 'hide-upload-btn': fileList.length >= 3 }">
                <el-upload
                  class="upload-demo"
                  accept=".jpg,.png,.jpeg"
                  list-type="picture-card"
                  action=""
                  :file-list="fileList"
                  :on-remove="handleRemove"
                  :limit="3"
                  :on-change="customUploadChange"
                  :headers="uploadHeaders"
                  :on-preview="handlePreview"
                  :http-request="customUploadRequest"
                  multiple
                >
                  <i class="el-icon-plus" v-show="fileList.length < 3"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="问题描述:" prop="problemDesc">
                <el-input v-model.trim="addForm.problemDesc" type="textarea" maxlength="500" :rows="2" placeholder="请输入描述信息" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remark">
                <el-input v-model.trim="addForm.remark" type="textarea" maxlength="100" :rows="2" placeholder="请输入备注信息" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </q-dialog>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import imgShow from '@/views/components/imgShow';
import { getToken } from '@/utils/auth';
import axios from '@/utils/axiosInstance';
export default {
  name: 'CRUDEdit',
  components: { imgShow },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    storeList: {
      type: Array,
      default: [],
    },
    violationQueryList: {
      type: Array,
      default: [],
    },
    sysConfigList: {
      type: Array,
      default: [],
    },
    rowData: Object,
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return !!this.rowData &&  !this.rowData.isQuery ? '编辑' : '新增';
    },
    userName() {
      return this.$store.state.user.name;
    },
    userId() {
      return this.$store.state.user.userId;
    },
  },
  data() {
    return {
      loadingButtom: false,
      loading: false,
      error: false,
      imgFormVisible: false,
      sumNumber: 0,
      isShowTable: true,
      addForm: {
        checkPerson: '',
        yearMonth: moment().format('YYYY-MM'),
        week: '',
        registerDt: moment().format('YYYY-MM-DD'),
        sessionDt: '',
        storeCode: '',
        customerId: '',
        customerServiceId: '',
        name: '',
        workJobs: '',
        violation: '',
        qualitySource: '',
        deductPoints: '',
        appealTime: 5,
        problemDesc: '',
        screenshotList: [],
        problemDesc: '',
        remark: '',
        qualityImgList: [],
        isQuery: ''
      },
      rules: {
        sessionDt: [{ required: true, message: '不能为空', trigger: 'change' }],
        storeCode: [{ required: true, message: '不能为空', trigger: 'change' }],
        customerId: [{ required: true, message: '不能为空', trigger: 'blur' }],
        customerServiceId: [{ required: true, message: '不能为空', trigger: 'change' }],
        violation: [{ required: true, message: '不能为空', trigger: 'change' }],
        deductPoints: [{ required: true, message: '不能为空', trigger: 'blur' }],
        appealTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
        problemDesc: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },
      textForm: {},
      skuCodeList: [],
      imgList: [],
      fileList: [],
      customerServiceIdList: [],
      uploadHeaders: {
        Authorization: getToken,
      },
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        hasCount: 'N',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    if (!!this.rowData) {
      Object.assign(this.addForm, this.rowData);
      let { qualityImgList, week, storeCode } = this.addForm;
      this.$set(this.addForm,'qualityImgList', qualityImgList ? qualityImgList : [])
      this.addForm.week = (Number(week.toString().slice(-2)))
      this.getUserInfo(storeCode, 2)
      this.fileList = qualityImgList && qualityImgList.length ? this.formatImg(qualityImgList) : [];
      return;
    }
    this.addForm.qualityPersonName = this.userName;
    this.addForm.qualityPersonId = this.userId;
    this.addForm.week = moment().isoWeek();
  },
  methods: {
    formatImg(list) {
      const imgList = list.map((v) => {
        return {
          name: v.split('/').pop(),
          url: v,
        };
      });
      return imgList;
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let screenshotList = this.addForm.screenshotList.map((v, index) => {
          return {
            fileName: this.addForm.customerId + `(${index + 1}) `,
            filePath: v,
          };
        });
        let data = {
          ...this.addForm,
          screenshotList: screenshotList,
        };
        this.$q.qualityTestingManage
          .registerUpdate({ data: data })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + '成功';
              this.$message.success(text);
              this.isVisible = false;
              this.$emit('success');
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    //其他补充图上传
    customUploadRequest(file) {
      let form = new FormData();
      form.append('files', file.file);
      form.append('appCode', 'ec-pc-new');
      this.$q.refundManagement.uploadMedia({ data: form }).then((res) => {
        this.addForm.qualityImgList.push(res.data[0].path);
        //检验绑定后有值错误信息依然显示问题解决
        // this.$refs.firstSetForm.validateField('otherImg', (err) => {
        //   return false;
        // });
      });
    },
    //其他补充图获取url
    customUploadChange(file) {
      this.fileList.push({
        name: file.name,
        url: file.url,
      });
    },
    //其他补充图删除
    handleRemove(file, fileList) {
      const index = this.fileList.findIndex((item) => item.url === file.url);
      this.addForm.qualityImgList.splice(index, 1);
      this.fileList.splice(index, 1);
    },
    handlePreview(file) {
      this.imgFormVisible = true;
      this.imgList = [file.url];
    },
    onviolationChange(val) {
      const item = this.violationQueryList.find((i) => i.scene === val);
      if (item) {
        this.addForm.deductPoints = item.deductPoints || '';
      }
    },
    getUserInfo(val, type) {
      if (type) {
        this.getCustomerServiceId(val,type);
      }
      let { storeCode, customerServiceId } = this.addForm;
      if (storeCode && customerServiceId) {
        let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
        currencyForm.param = {
          storeCode,
          platCustomerServiceId: customerServiceId,
        };
        currencyForm.reportCode = 'customerServiceInfo';
        axios.post(`/ec-pc-api/custom/reports/data/customerServiceInfo`, currencyForm).then((res) => {
          if (res.code == 200) {
            let isData = res.data.list[0];
            this.addForm.workJobs = isData ? isData.workJobs : '';
            this.addForm.name = isData ? isData.name : '';
          }
        });
      }
    },
    //平台客户id
    getCustomerServiceId(val,type) {
      if(type === 1) {
        this.$set(this.addForm, 'customerServiceId', '');
      }
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = 'customerServiceId';
      currencyForm.param = {
        storeCode: val || '',
      };
      axios.post(`/ec-pc-api/custom/reports/data/customerServiceId`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.customerServiceIdList = res.data.list;
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="stylus" scoped>
>>> .el-dialog__body {
  padding-right: 10px !important
  overflow-y: auto;
  overflow-x: hidden;
}

.content {
  max-height: 70vh;
}

>>> .el-form-item {
  margin-bottom: 18px;
}

>>> .el-dialog {
  margin: 50px auto !important;
}

>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner {
  width: 260px !important;
}

>>> .el-input {
  width: 260px !important;
}

>>> .el-input-number--small {
  width: 260px !important;
}

>>> ::-webkit-scrollbar {
  width: 6px;
}

>>> ::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  workJobs: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}

>>> .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
  vertical-align: top;
  margin-right: 8px;
}

>>> .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  vertical-align: top;
  margin-right: 8px;
}
.upload-demo {
  display: flex;
  align-items: flex-start;
}

.hide-upload-btn >>> .el-upload--picture-card {
  display: none !important;
}
</style>
